import React from "react"
import CTARow from "../components/cta-row"
import HomeHero from "../components/home-hero"
import Layout from "../components/layout"
import OverlayBlurb from "../components/overlay-blurb"
import VideoLightbox from "../components/video-lightbox"
import CalendlyPopUp from "../components/calendly/calendly-popup"
 
import SEO from "../components/seo"

var content = {
  hero: {
    title: (
      <span>
        Teach Cyber Security <br /> with Project Ares
      </span>
    ),
    text:
      "Professors: Do you struggle to keep students engaged in the cyber security classroom? Are you looking for ways to make learning more hands-on so students build real-world skills? Project Ares is an award-winning online cyber security learning platform suitable for remote or in-person teaching.",
  },

 

  cta1: {
    title: " ",
    text:
      "Project Ares is an award-winning, gamified cyber security learning platform that helps students and professionals build and keep skills sharp against evolving cyber threats. Practice and progress in the hands-on platform with foundational, intermediate and advanced cyber learning content. Its patented cyber range-as-a-service technology delivers authentic virtual machine-based exercises so cyber preparation is as true-to-life as it gets.",
    url:
      "https://marketing.circadence.com/acton/media/36273/webinar-kickstarting-a-cyber-career-2019-11",
    cta: "Watch Trailer",
  },
}
 


class IndexPage extends React.Component{  



  constructor(props) {
    super(props)
    this.state = {
      trailerLightbox: false,
      calendlyLightbox: false,
    }
  
  
    this.handleOpenTrailer = this.handleOpenTrailer.bind(this);
    this.handleCloseTrailer = this.handleCloseTrailer.bind(this);
    this.handleOpenCalendly = this.handleOpenCalendly.bind(this);
    this.handleCloseCalendly = this.handleCloseCalendly.bind(this);
  
  }

handleOpenTrailer(){
this.setState({
  trailerLightbox:true
})

}


handleOpenCalendly(){
  this.setState({
    calendlyLightbox:true
  })
  
  }

handleCloseTrailer(){
  this.setState({
    trailerLightbox:false
  })}


  
handleCloseCalendly(){
  this.setState({
    calendlyLightbox:false
  })}
  
render(){

  return (
    
    <Layout>
         <SEO />
      <HomeHero/>
   <OverlayBlurb/>
 
   <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
         
          inv={false}
          calendly={<CalendlyPopUp/>}
          click={this.handleOpenTrailer}
          bgColor={"bright-blue"}
          image={"laptop"}
        />

 
<VideoLightbox visible={this.state.trailerLightbox} close={this.handleCloseTrailer}/>
    </Layout>
  )}
}

export default IndexPage




